import styled from 'styled-components'
import { Form } from 'formik'
import { Link as ReactLink } from 'react-router-dom'
import { SemiTitle } from 'components/Typography'

export const Link = styled(ReactLink)`
  color: ${({ color }) => color};
`

export const SignUpTitle = styled(SemiTitle)`
  text-align: center;
`
